import styled from 'styled-components';
import { AlertIcon } from 'styles/components';
import { Colors, getScrollbarStyle } from 'styles/constants';
export { Button, ActivityIndicator } from 'styles/components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  flex-direction: column;
  background-color: ${Colors.White};
  border-radius: 4px;
  padding: 40px;
  margin: 32px 0;

  ${getScrollbarStyle()}
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px ${Colors.Gray50} solid;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-size: 20px;
  color: ${Colors.Black};
  margin-left: 10px;
`;

export const Text = styled.article`
  width: 100%;
  font-size: 16px;
  color: ${Colors.Gray70};
  margin-bottom: 48px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  border-left: none;
  border-right: none;

  button:first-child {
    margin-right: 16px;
  }
`;

export const IconWarning = styled(AlertIcon)`
  width: 24px;
  height: 24px;
  path {
    fill: none;
  }
`;
